class UpcartAddOn extends HTMLElement {
  constructor() {
    super();
    console.log("UpcartAddOn");
  }

  connectedCallback() {
    this.abortController = new AbortController();

    this.toggleInput.addEventListener(
      "change",
      (event) => {
        if (event.target.checked) {
          this.toggleOffOtherAddOns();
          this.toggleOn();
        } else {
          this.toggleOff();
        }
      },
      { signal: this.abortController.signal }
    );
  }

  disconnectedCallback() {
    this.abortController?.abort();
  }

  toggleOff() {
    this.toggleInput.checked = false;
    this.content.classList.add("hidden");
  }

  toggleOn() {
    this.toggleInput.checked = true;
    this.content.classList.remove("hidden");
  }

  toggleOffOtherAddOns() {
    this.otherAddOns.forEach((addOn) => {
      if (addOn !== this) {
        addOn.toggleOff();
      }
    });
  }

  get toggleInput() {
    return this.querySelector(".upcart-add-on__toggle-input");
  }

  get content() {
    return this.querySelector(".upcart-add-on__content");
  }

  get otherAddOns() {
    return this.closest(".upcart-add-ons").querySelectorAll(".upcart-add-on");
  }
}

if (!customElements.get("upcart-add-on")) {
  customElements.define("upcart-add-on", UpcartAddOn);
}
